<div class="layout-auto-1-auto">
  <div></div>
  <div class="content">
    <div class="db-container db-container-layout bg-transparent app-db-container" style="--db-width: 100%">

      <div class="db-header">
        <h1>{{db.title}}</h1>
        <div class="spawn" style="margin-bottom:2rem;">
          <ng-container *ngFor="let w of db.titleWidgets">
            <exg-widget [name]="w.widget" [data]="w.data"></exg-widget>
          </ng-container>
        </div>
        <h2>{{db.version}}</h2>
      </div>

      <ng-container *ngFor="let e of db.sections">
        <h1>{{e.caption}}</h1>
        <div [ngClass]="'db-section-' + e.columns">

          <div class="db-clip" *ngFor="let w of e.widgets ">
            <h1>{{w.title}}</h1>
            <h2>{{w.description}}</h2>
            <exg-widget [name]="w.widget" [data]="w.data"></exg-widget>
          </div>

        </div>
      </ng-container>
      <ng-container *ngIf="db.noData">
        <div class="splash empty" style="top: 20rem">
          <p>{{getRessource('zeroRows')}}</p>
        </div>
      </ng-container>
    </div>
  </div>
</div>
